import MaterialIcon from '@material/react-material-icon';
import React from 'react';
import PropTypes from 'prop-types';

const MyButton = (props) => {
  const { type, text, action, size, outline } = props;

  const icon = {
    add: 'add_circle',
    edit: 'edit',
    update: 'update',
    delete: 'delete',
  }[type];

  const color = {
    add: 'primary',
    edit: 'secondary',
    update: 'success',
    delete: 'danger',
  }[type];

  return (
    <button
      type="button"
      className={`btn btn-${outline ? 'outline-' : ''}${color} btn-${size || 'md'} rounded-4`}
      onClick={action}
    >
      <div className="d-flex align-items-center gap-1">
        <MaterialIcon icon={icon} style={{ fontSize: '16px' }} />
        <span>{text}</span>
      </div>
    </button>
  );
};

MyButton.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string,
  action: PropTypes.func,
  size: PropTypes.string,
  outline: PropTypes.bool,
};

export default MyButton;
